import {TimelineLite, TweenLite} from "gsap";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ISymbolPositions} from "../winpresentation/geniefeature/GenieFeatureController";
import {ScatterAnimTypes} from "../enums/ScatterAnimTypes";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class ScatterAnimationView extends PIXI.Container {
    private _layer: StageLayer;
    private _scatterAnimTl: TimelineLite;
    private _isScatterAnticipationAnimPlaying: boolean = false;
    private _isScatterTriggerAnimPlaying: boolean = false;

    constructor() {
        super();
        this.name = "SCATTER_ANIMATION_VIEW";
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.SCATTER_ANIMATION.name);
        this._layer.addChild(this);
    }

    public resetScatterAnimation() {
        if (this._scatterAnimTl && this._scatterAnimTl.isActive()) {
            this._scatterAnimTl.pause().kill();
        }
        this.removeChildren();
        this._isScatterAnticipationAnimPlaying = false;
        this._isScatterTriggerAnimPlaying = false;
    }

    public playScatterAnimation(scatterPos: number[], animType: ScatterAnimTypes, reelId: number) {
        if (animType === ScatterAnimTypes.ANTICIPATION && this._isScatterAnticipationAnimPlaying) {
            return;
        }
        if (animType === ScatterAnimTypes.TRIGGER && this._isScatterTriggerAnimPlaying) {
            //return;
        }
        this.resetScatterAnimation();
        this._scatterAnimTl = new TimelineLite({ paused: true });

        for (let index = 0; index <= reelId; index++) {
            const value = scatterPos[index];
            if (value != -1) {
                const symPos: ISymbolPositions = { reelId: index, symbolId: value };
                const pos = Helper.getSymbolPositions(index, value);
                const scatterAnticipationAnim = this.getScatterSprite("scatterAnticipationIdle", symPos);

                if (animType === ScatterAnimTypes.ANTICIPATION) {
                    this._isScatterAnticipationAnimPlaying = true;
                    this._isScatterTriggerAnimPlaying = false;
                    const scatterAnticipationAnimBlend = this.getScatterSprite("scatterAnticipationIdle", symPos);
                    scatterAnticipationAnimBlend.alpha = 0;
                    scatterAnticipationAnimBlend.blendMode = PIXI.BLEND_MODES.ADD;
                    this.addChild(scatterAnticipationAnim);
                    this.addChild(scatterAnticipationAnimBlend);
                    this._scatterAnimTl.add([
                        () => this.toggleAlphaTween(scatterAnticipationAnimBlend, scatterAnticipationAnim.totalDuration, true),
                        () => scatterAnticipationAnim.playLoop()
                    ], 0);
                } else if (animType === ScatterAnimTypes.TRIGGER) {
                    this._isScatterAnticipationAnimPlaying = false;
                    this._isScatterTriggerAnimPlaying = true;
                    const scatterAnticipationAnimBlend = this.getScatterSprite("scatterAnticipationIdle", symPos);
                    scatterAnticipationAnimBlend.alpha = 0;
                    const scatterRaysSprite = this.createScatterRaysSprite(pos);
                    const triggerOverlayUp = this.createTriggerOverlay(pos, true);
                    const triggerOverlayDown = this.createTriggerOverlay(pos, false);
                    const scatterAnticipationAnimForMask = this.getScatterSprite("scatterAnticipationIdle", symPos);
                    const gfx = this.createScatterMask(pos);
                    gfx.mask = scatterAnticipationAnimForMask;
                    scatterAnticipationAnimBlend.blendMode = PIXI.BLEND_MODES.ADD;
                    this.addChild(scatterRaysSprite);
                    this.addChild(triggerOverlayUp, triggerOverlayDown);
                    this.addChild(scatterAnticipationAnim);
                    this.addChild(scatterAnticipationAnimBlend);
                    this.addChild(scatterAnticipationAnimForMask, gfx);
                    const gfxTl = new TimelineLite({
                        onComplete: function () {
                            //this.restart();
                        }
                    });

                    gfxTl.add(TweenLite.fromTo(gfx, scatterAnticipationAnim.totalDuration, { y: pos[1] - RomanEmpireGameConfig.instance.SYMBOL_HEIGHT * 2 },
                        { y: pos[1] + RomanEmpireGameConfig.instance.SYMBOL_HEIGHT * 1.5 }), 0.1);
                    this._scatterAnimTl.add(
                        [
                            () => gfxTl,
                            () => this.toggleScaleTween(scatterAnticipationAnim, scatterAnticipationAnim.totalDuration, false),
                            () => this.toggleScaleTween(scatterAnticipationAnimBlend, scatterAnticipationAnim.totalDuration, false),
                            () => this.toggleAlphaTween(scatterAnticipationAnimBlend, scatterAnticipationAnim.totalDuration, false),
                            () => this.toggleAlphaTween(scatterRaysSprite, scatterAnticipationAnim.totalDuration, false),
                            () => triggerOverlayUp.getAnimationAutoShowHide(true, true),
                            () => triggerOverlayDown.getAnimationAutoShowHide(true, true),
                            () => scatterAnticipationAnim.playLoop()
                        ], 0);
                } else {
                    this.addChild(scatterAnticipationAnim);
                    this._scatterAnimTl.add(scatterAnticipationAnim.getAnimationAutoShowHide(true, true));
                    this._scatterAnimTl.add(scatterAnticipationAnim.getAnimationAutoShowHide(true, true));
                }

            }
        }
        this._scatterAnimTl.play();
    }


    private createScatterMask(pos: number[]): PIXI.Graphics {
        const gfx: PIXI.Graphics = new PIXI.Graphics();
        //gfx.blendMode = PIXI.BLEND_MODES.ADD;
        gfx.beginFill(0xFFFFFFFF, 1);
        gfx.drawRect(0, 0, RomanEmpireGameConfig.instance.SYMBOL_WIDTH * 2, 80);
        this.addChild(gfx);
        gfx.pivot.set(gfx.width * 0.5, gfx.height * 0.5);
        gfx.rotation = -0.5;
        gfx.position.set(pos[0], pos[1]);
        return gfx;
    }

    private toggleAlphaTween(obj: PIXI.DisplayObject, duration: number, loop: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                loop && tl.restart();
            }
        });
        tl.add(TweenLite.fromTo(obj, duration * 0.5, { alpha: 0 }, { alpha: 0.8 }));
        tl.add(TweenLite.fromTo(obj, duration * 0.5, { alpha: 0.8 }, { alpha: 0 }));
        return tl;
    }

    private toggleScaleTween(obj: PIXI.DisplayObject, duration: number, loop: boolean = false, scale: number = 1.08): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            onComplete: () => {
                loop && tl.restart();
            }
        });
        tl.add(TweenLite.to(obj.scale, duration *0.12, { x: scale, y: scale }), 0.1);
        tl.add(TweenLite.to(obj.scale, duration * 0.12, { x: 1, y: 1 }));
        tl.add(TweenLite.fromTo(obj.scale, duration, {}, {}), 0);
        return tl;
    }

    public getScatterSprite(textureStr: string, position?: ISymbolPositions): TimelineSprite {
        const textures: PIXI.Texture[] = GameResources.getTextures(textureStr);
        const sprite: TimelineSprite = new TimelineSprite(textures, 30);
        sprite.anchor.set(0.5, 0.5);
        if (position) {
            const pos = Helper.getSymbolPositions(position.reelId, position.symbolId);
            sprite.position.set(pos[0], pos[1]);
        }
        return sprite;
    }

    /**
     * To get sprite by texture name
     * @param texture
     */
    private getSpriteByTexture(texture: string): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(texture)[0]);
        sprite.anchor.set(0.5, 0.5);
        return sprite;
    }

    private createScatterRaysSprite(pos: number[]): PIXI.Sprite {
        const scatterRaysSprite = this.getSpriteByTexture("scatterRays");
        scatterRaysSprite.position.set(pos[0] + 7, pos[1]);
        scatterRaysSprite.blendMode = PIXI.BLEND_MODES.ADD;
        return scatterRaysSprite;
    }

    private createTriggerOverlay(pos: number[], isUp: boolean): TimelineSprite {
        const triggerOverlay = this.getScatterSprite("scatterTriggerOverlay");
        const reverseNum: number = isUp ? 1 : -1;
        triggerOverlay.position.set(pos[0], pos[1] - (RomanEmpireGameConfig.instance.SYMBOL_HEIGHT * 0.5 * reverseNum));
        triggerOverlay.blendMode = PIXI.BLEND_MODES.ADD;
        triggerOverlay.scale.x *= reverseNum;
        triggerOverlay.scale.y *= reverseNum;
        return triggerOverlay;
    }
}